'use client';

import { useEffect, useState } from 'react';

import { IS_SSR } from '../../constants';
import { type ConsentGroup, hasConsentGroup } from '../utils';

export const useConsentCategory = (category: ConsentGroup) => {
    const [enabled, setEnabled] = useState(() => {
        if (IS_SSR) return false;

        return hasConsentGroup({ group: category, groups: window.OnetrustActiveGroups });
    });

    useEffect(() => {
        const readConsent = (event?: WindowEventMap['OneTrustGroupsUpdated']) => {
            const groups = event?.detail ?? window.OnetrustActiveGroups;
            setEnabled(hasConsentGroup({ group: category, groups }));
        };

        readConsent();
        window.addEventListener('OneTrustGroupsUpdated', readConsent);
        return () => window.removeEventListener('OneTrustGroupsUpdated', readConsent);
    }, [category]);

    return enabled;
};
